/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AuthenticatedIBCompletePerformanceRouteImport } from './routes/_authenticated/_IBComplete/performance'
import { Route as UnauthenticatedLogoutCallbackRouteImport } from './routes/_unauthenticated/logout/callback'
import { Route as AuthenticatedIBCompleteIbNetworkYourSubIbsRouteImport } from './routes/_authenticated/_IBComplete/ib-network/your-sub-ibs'
import { Route as AuthenticatedIBCompleteMarketingIndexRouteImport } from './routes/_authenticated/_IBComplete/marketing/index'

const AuthenticatedIndexLazyRouteImport = createFileRoute('/_authenticated/')()
const AuthenticatedIBCompleteLazyRouteImport = createFileRoute(
  '/_authenticated/_IBComplete',
)()
const AuthenticatedIBOnboardingLazyRouteImport = createFileRoute(
  '/_authenticated/_IBOnboarding',
)()
const UnauthenticatedInactivityLogoutLazyRouteImport = createFileRoute(
  '/_unauthenticated/inactivity-logout',
)()
const UnauthenticatedProgramSelectionLazyRouteImport = createFileRoute(
  '/_unauthenticated/program-selection',
)()
const AuthenticatedIBCompleteClientsLazyRouteImport = createFileRoute(
  '/_authenticated/_IBComplete/clients',
)()
const AuthenticatedIBCompleteEarningsLazyRouteImport = createFileRoute(
  '/_authenticated/_IBComplete/earnings',
)()
const AuthenticatedIBCompleteExportReportLazyRouteImport = createFileRoute(
  '/_authenticated/_IBComplete/export-report',
)()
const AuthenticatedIBCompleteLeadsLazyRouteImport = createFileRoute(
  '/_authenticated/_IBComplete/leads',
)()
const AuthenticatedIBCompleteMarketingLazyRouteImport = createFileRoute(
  '/_authenticated/_IBComplete/marketing',
)()
const AuthenticatedIBOnboardingKycLazyRouteImport = createFileRoute(
  '/_authenticated/_IBOnboarding/kyc',
)()
const AuthenticatedIBOnboardingQuestionnaireLazyRouteImport = createFileRoute(
  '/_authenticated/_IBOnboarding/questionnaire',
)()
const AuthenticatedTriageIndexLazyRouteImport = createFileRoute(
  '/_authenticated/triage/',
)()
const AuthenticatedTriageTriageIDLazyRouteImport = createFileRoute(
  '/_authenticated/triage/$triageID',
)()
const AuthenticatedTriageHistoryLazyRouteImport = createFileRoute(
  '/_authenticated/triage/history',
)()
const AuthenticatedIBCompleteIbNetworkIndexLazyRouteImport = createFileRoute(
  '/_authenticated/_IBComplete/ib-network/',
)()
const AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRouteImport =
  createFileRoute('/_authenticated/_IBComplete/ib-network/your-master-ib')()
const AuthenticatedIBCompleteMarketingBannerLibraryLazyRouteImport =
  createFileRoute('/_authenticated/_IBComplete/marketing/banner-library')()
const AuthenticatedTriageIbIndexLazyRouteImport = createFileRoute(
  '/_authenticated/triage/ib/',
)()
const AuthenticatedTriageIbTriageIDLazyRouteImport = createFileRoute(
  '/_authenticated/triage/ib/$triageID',
)()
const AuthenticatedTriageMamIndexLazyRouteImport = createFileRoute(
  '/_authenticated/triage/mam/',
)()
const AuthenticatedTriageMamTriageIdLazyRouteImport = createFileRoute(
  '/_authenticated/triage/mam/$triageId',
)()

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexLazyRoute = AuthenticatedIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/index.lazy').then((d) => d.Route),
)
const AuthenticatedIBCompleteLazyRoute =
  AuthenticatedIBCompleteLazyRouteImport.update({
    id: '/_IBComplete',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete.lazy').then((d) => d.Route),
  )
const AuthenticatedIBOnboardingLazyRoute =
  AuthenticatedIBOnboardingLazyRouteImport.update({
    id: '/_IBOnboarding',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBOnboarding.lazy').then((d) => d.Route),
  )
const UnauthenticatedInactivityLogoutLazyRoute =
  UnauthenticatedInactivityLogoutLazyRouteImport.update({
    id: '/inactivity-logout',
    path: '/inactivity-logout',
    getParentRoute: () => UnauthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_unauthenticated/inactivity-logout.lazy').then(
      (d) => d.Route,
    ),
  )
const UnauthenticatedProgramSelectionLazyRoute =
  UnauthenticatedProgramSelectionLazyRouteImport.update({
    id: '/program-selection',
    path: '/program-selection',
    getParentRoute: () => UnauthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_unauthenticated/program-selection.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompleteClientsLazyRoute =
  AuthenticatedIBCompleteClientsLazyRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AuthenticatedIBCompleteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/clients.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompleteEarningsLazyRoute =
  AuthenticatedIBCompleteEarningsLazyRouteImport.update({
    id: '/earnings',
    path: '/earnings',
    getParentRoute: () => AuthenticatedIBCompleteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/earnings.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompleteExportReportLazyRoute =
  AuthenticatedIBCompleteExportReportLazyRouteImport.update({
    id: '/export-report',
    path: '/export-report',
    getParentRoute: () => AuthenticatedIBCompleteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/export-report.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompleteLeadsLazyRoute =
  AuthenticatedIBCompleteLeadsLazyRouteImport.update({
    id: '/leads',
    path: '/leads',
    getParentRoute: () => AuthenticatedIBCompleteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/leads.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompleteMarketingLazyRoute =
  AuthenticatedIBCompleteMarketingLazyRouteImport.update({
    id: '/marketing',
    path: '/marketing',
    getParentRoute: () => AuthenticatedIBCompleteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/marketing.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompletePerformanceRoute =
  AuthenticatedIBCompletePerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthenticatedIBCompleteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/performance.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBOnboardingKycLazyRoute =
  AuthenticatedIBOnboardingKycLazyRouteImport.update({
    id: '/kyc',
    path: '/kyc',
    getParentRoute: () => AuthenticatedIBOnboardingLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBOnboarding/kyc.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBOnboardingQuestionnaireLazyRoute =
  AuthenticatedIBOnboardingQuestionnaireLazyRouteImport.update({
    id: '/questionnaire',
    path: '/questionnaire',
    getParentRoute: () => AuthenticatedIBOnboardingLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBOnboarding/questionnaire.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTriageIndexLazyRoute =
  AuthenticatedTriageIndexLazyRouteImport.update({
    id: '/triage/',
    path: '/triage/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/triage/index.lazy').then((d) => d.Route),
  )
const AuthenticatedTriageTriageIDLazyRoute =
  AuthenticatedTriageTriageIDLazyRouteImport.update({
    id: '/triage/$triageID',
    path: '/triage/$triageID',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/triage/$triageID.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTriageHistoryLazyRoute =
  AuthenticatedTriageHistoryLazyRouteImport.update({
    id: '/triage/history',
    path: '/triage/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/triage/history.lazy').then((d) => d.Route),
  )
const UnauthenticatedLogoutCallbackRoute =
  UnauthenticatedLogoutCallbackRouteImport.update({
    id: '/logout/callback',
    path: '/logout/callback',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedIBCompleteIbNetworkIndexLazyRoute =
  AuthenticatedIBCompleteIbNetworkIndexLazyRouteImport.update({
    id: '/ib-network/',
    path: '/ib-network/',
    getParentRoute: () => AuthenticatedIBCompleteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/ib-network/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRoute =
  AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRouteImport.update({
    id: '/ib-network/your-master-ib',
    path: '/ib-network/your-master-ib',
    getParentRoute: () => AuthenticatedIBCompleteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/ib-network/your-master-ib.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompleteIbNetworkYourSubIbsRoute =
  AuthenticatedIBCompleteIbNetworkYourSubIbsRouteImport.update({
    id: '/ib-network/your-sub-ibs',
    path: '/ib-network/your-sub-ibs',
    getParentRoute: () => AuthenticatedIBCompleteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/ib-network/your-sub-ibs.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompleteMarketingIndexRoute =
  AuthenticatedIBCompleteMarketingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedIBCompleteMarketingLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/marketing/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIBCompleteMarketingBannerLibraryLazyRoute =
  AuthenticatedIBCompleteMarketingBannerLibraryLazyRouteImport.update({
    id: '/banner-library',
    path: '/banner-library',
    getParentRoute: () => AuthenticatedIBCompleteMarketingLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_IBComplete/marketing/banner-library.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTriageIbIndexLazyRoute =
  AuthenticatedTriageIbIndexLazyRouteImport.update({
    id: '/triage/ib/',
    path: '/triage/ib/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/triage/ib/index.lazy').then((d) => d.Route),
  )
const AuthenticatedTriageIbTriageIDLazyRoute =
  AuthenticatedTriageIbTriageIDLazyRouteImport.update({
    id: '/triage/ib/$triageID',
    path: '/triage/ib/$triageID',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/triage/ib/$triageID.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTriageMamIndexLazyRoute =
  AuthenticatedTriageMamIndexLazyRouteImport.update({
    id: '/triage/mam/',
    path: '/triage/mam/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/triage/mam/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTriageMamTriageIdLazyRoute =
  AuthenticatedTriageMamTriageIdLazyRouteImport.update({
    id: '/triage/mam/$triageId',
    path: '/triage/mam/$triageId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/triage/mam/$triageId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexLazyRoute
  '/signup': typeof SignupRoute
  '/inactivity-logout': typeof UnauthenticatedInactivityLogoutLazyRoute
  '/program-selection': typeof UnauthenticatedProgramSelectionLazyRoute
  '/performance': typeof AuthenticatedIBCompletePerformanceRoute
  '/logout/callback': typeof UnauthenticatedLogoutCallbackRoute
  '/clients': typeof AuthenticatedIBCompleteClientsLazyRoute
  '/earnings': typeof AuthenticatedIBCompleteEarningsLazyRoute
  '/export-report': typeof AuthenticatedIBCompleteExportReportLazyRoute
  '/leads': typeof AuthenticatedIBCompleteLeadsLazyRoute
  '/marketing': typeof AuthenticatedIBCompleteMarketingLazyRouteWithChildren
  '/kyc': typeof AuthenticatedIBOnboardingKycLazyRoute
  '/questionnaire': typeof AuthenticatedIBOnboardingQuestionnaireLazyRoute
  '/triage/$triageID': typeof AuthenticatedTriageTriageIDLazyRoute
  '/triage/history': typeof AuthenticatedTriageHistoryLazyRoute
  '/triage/': typeof AuthenticatedTriageIndexLazyRoute
  '/ib-network/your-sub-ibs': typeof AuthenticatedIBCompleteIbNetworkYourSubIbsRoute
  '/ib-network/your-master-ib': typeof AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRoute
  '/marketing/banner-library': typeof AuthenticatedIBCompleteMarketingBannerLibraryLazyRoute
  '/triage/ib/$triageID': typeof AuthenticatedTriageIbTriageIDLazyRoute
  '/triage/mam/$triageId': typeof AuthenticatedTriageMamTriageIdLazyRoute
  '/marketing/': typeof AuthenticatedIBCompleteMarketingIndexRoute
  '/ib-network/': typeof AuthenticatedIBCompleteIbNetworkIndexLazyRoute
  '/triage/ib/': typeof AuthenticatedTriageIbIndexLazyRoute
  '/triage/mam/': typeof AuthenticatedTriageMamIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexLazyRoute
  '/signup': typeof SignupRoute
  '/inactivity-logout': typeof UnauthenticatedInactivityLogoutLazyRoute
  '/program-selection': typeof UnauthenticatedProgramSelectionLazyRoute
  '/performance': typeof AuthenticatedIBCompletePerformanceRoute
  '/logout/callback': typeof UnauthenticatedLogoutCallbackRoute
  '/clients': typeof AuthenticatedIBCompleteClientsLazyRoute
  '/earnings': typeof AuthenticatedIBCompleteEarningsLazyRoute
  '/export-report': typeof AuthenticatedIBCompleteExportReportLazyRoute
  '/leads': typeof AuthenticatedIBCompleteLeadsLazyRoute
  '/kyc': typeof AuthenticatedIBOnboardingKycLazyRoute
  '/questionnaire': typeof AuthenticatedIBOnboardingQuestionnaireLazyRoute
  '/triage/$triageID': typeof AuthenticatedTriageTriageIDLazyRoute
  '/triage/history': typeof AuthenticatedTriageHistoryLazyRoute
  '/triage': typeof AuthenticatedTriageIndexLazyRoute
  '/ib-network/your-sub-ibs': typeof AuthenticatedIBCompleteIbNetworkYourSubIbsRoute
  '/ib-network/your-master-ib': typeof AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRoute
  '/marketing/banner-library': typeof AuthenticatedIBCompleteMarketingBannerLibraryLazyRoute
  '/triage/ib/$triageID': typeof AuthenticatedTriageIbTriageIDLazyRoute
  '/triage/mam/$triageId': typeof AuthenticatedTriageMamTriageIdLazyRoute
  '/marketing': typeof AuthenticatedIBCompleteMarketingIndexRoute
  '/ib-network': typeof AuthenticatedIBCompleteIbNetworkIndexLazyRoute
  '/triage/ib': typeof AuthenticatedTriageIbIndexLazyRoute
  '/triage/mam': typeof AuthenticatedTriageMamIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/signup': typeof SignupRoute
  '/_authenticated/_IBComplete': typeof AuthenticatedIBCompleteLazyRouteWithChildren
  '/_authenticated/_IBOnboarding': typeof AuthenticatedIBOnboardingLazyRouteWithChildren
  '/_unauthenticated/inactivity-logout': typeof UnauthenticatedInactivityLogoutLazyRoute
  '/_unauthenticated/program-selection': typeof UnauthenticatedProgramSelectionLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexLazyRoute
  '/_authenticated/_IBComplete/performance': typeof AuthenticatedIBCompletePerformanceRoute
  '/_unauthenticated/logout/callback': typeof UnauthenticatedLogoutCallbackRoute
  '/_authenticated/_IBComplete/clients': typeof AuthenticatedIBCompleteClientsLazyRoute
  '/_authenticated/_IBComplete/earnings': typeof AuthenticatedIBCompleteEarningsLazyRoute
  '/_authenticated/_IBComplete/export-report': typeof AuthenticatedIBCompleteExportReportLazyRoute
  '/_authenticated/_IBComplete/leads': typeof AuthenticatedIBCompleteLeadsLazyRoute
  '/_authenticated/_IBComplete/marketing': typeof AuthenticatedIBCompleteMarketingLazyRouteWithChildren
  '/_authenticated/_IBOnboarding/kyc': typeof AuthenticatedIBOnboardingKycLazyRoute
  '/_authenticated/_IBOnboarding/questionnaire': typeof AuthenticatedIBOnboardingQuestionnaireLazyRoute
  '/_authenticated/triage/$triageID': typeof AuthenticatedTriageTriageIDLazyRoute
  '/_authenticated/triage/history': typeof AuthenticatedTriageHistoryLazyRoute
  '/_authenticated/triage/': typeof AuthenticatedTriageIndexLazyRoute
  '/_authenticated/_IBComplete/ib-network/your-sub-ibs': typeof AuthenticatedIBCompleteIbNetworkYourSubIbsRoute
  '/_authenticated/_IBComplete/ib-network/your-master-ib': typeof AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRoute
  '/_authenticated/_IBComplete/marketing/banner-library': typeof AuthenticatedIBCompleteMarketingBannerLibraryLazyRoute
  '/_authenticated/triage/ib/$triageID': typeof AuthenticatedTriageIbTriageIDLazyRoute
  '/_authenticated/triage/mam/$triageId': typeof AuthenticatedTriageMamTriageIdLazyRoute
  '/_authenticated/_IBComplete/marketing/': typeof AuthenticatedIBCompleteMarketingIndexRoute
  '/_authenticated/_IBComplete/ib-network/': typeof AuthenticatedIBCompleteIbNetworkIndexLazyRoute
  '/_authenticated/triage/ib/': typeof AuthenticatedTriageIbIndexLazyRoute
  '/_authenticated/triage/mam/': typeof AuthenticatedTriageMamIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signup'
    | '/inactivity-logout'
    | '/program-selection'
    | '/performance'
    | '/logout/callback'
    | '/clients'
    | '/earnings'
    | '/export-report'
    | '/leads'
    | '/marketing'
    | '/kyc'
    | '/questionnaire'
    | '/triage/$triageID'
    | '/triage/history'
    | '/triage/'
    | '/ib-network/your-sub-ibs'
    | '/ib-network/your-master-ib'
    | '/marketing/banner-library'
    | '/triage/ib/$triageID'
    | '/triage/mam/$triageId'
    | '/marketing/'
    | '/ib-network/'
    | '/triage/ib/'
    | '/triage/mam/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signup'
    | '/inactivity-logout'
    | '/program-selection'
    | '/performance'
    | '/logout/callback'
    | '/clients'
    | '/earnings'
    | '/export-report'
    | '/leads'
    | '/kyc'
    | '/questionnaire'
    | '/triage/$triageID'
    | '/triage/history'
    | '/triage'
    | '/ib-network/your-sub-ibs'
    | '/ib-network/your-master-ib'
    | '/marketing/banner-library'
    | '/triage/ib/$triageID'
    | '/triage/mam/$triageId'
    | '/marketing'
    | '/ib-network'
    | '/triage/ib'
    | '/triage/mam'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/signup'
    | '/_authenticated/_IBComplete'
    | '/_authenticated/_IBOnboarding'
    | '/_unauthenticated/inactivity-logout'
    | '/_unauthenticated/program-selection'
    | '/_authenticated/'
    | '/_authenticated/_IBComplete/performance'
    | '/_unauthenticated/logout/callback'
    | '/_authenticated/_IBComplete/clients'
    | '/_authenticated/_IBComplete/earnings'
    | '/_authenticated/_IBComplete/export-report'
    | '/_authenticated/_IBComplete/leads'
    | '/_authenticated/_IBComplete/marketing'
    | '/_authenticated/_IBOnboarding/kyc'
    | '/_authenticated/_IBOnboarding/questionnaire'
    | '/_authenticated/triage/$triageID'
    | '/_authenticated/triage/history'
    | '/_authenticated/triage/'
    | '/_authenticated/_IBComplete/ib-network/your-sub-ibs'
    | '/_authenticated/_IBComplete/ib-network/your-master-ib'
    | '/_authenticated/_IBComplete/marketing/banner-library'
    | '/_authenticated/triage/ib/$triageID'
    | '/_authenticated/triage/mam/$triageId'
    | '/_authenticated/_IBComplete/marketing/'
    | '/_authenticated/_IBComplete/ib-network/'
    | '/_authenticated/triage/ib/'
    | '/_authenticated/triage/mam/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_IBComplete': {
      id: '/_authenticated/_IBComplete'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIBCompleteLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_IBOnboarding': {
      id: '/_authenticated/_IBOnboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIBOnboardingLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_unauthenticated/inactivity-logout': {
      id: '/_unauthenticated/inactivity-logout'
      path: '/inactivity-logout'
      fullPath: '/inactivity-logout'
      preLoaderRoute: typeof UnauthenticatedInactivityLogoutLazyRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/program-selection': {
      id: '/_unauthenticated/program-selection'
      path: '/program-selection'
      fullPath: '/program-selection'
      preLoaderRoute: typeof UnauthenticatedProgramSelectionLazyRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/_IBComplete/clients': {
      id: '/_authenticated/_IBComplete/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthenticatedIBCompleteClientsLazyRouteImport
      parentRoute: typeof AuthenticatedIBCompleteLazyRoute
    }
    '/_authenticated/_IBComplete/earnings': {
      id: '/_authenticated/_IBComplete/earnings'
      path: '/earnings'
      fullPath: '/earnings'
      preLoaderRoute: typeof AuthenticatedIBCompleteEarningsLazyRouteImport
      parentRoute: typeof AuthenticatedIBCompleteLazyRoute
    }
    '/_authenticated/_IBComplete/export-report': {
      id: '/_authenticated/_IBComplete/export-report'
      path: '/export-report'
      fullPath: '/export-report'
      preLoaderRoute: typeof AuthenticatedIBCompleteExportReportLazyRouteImport
      parentRoute: typeof AuthenticatedIBCompleteLazyRoute
    }
    '/_authenticated/_IBComplete/leads': {
      id: '/_authenticated/_IBComplete/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AuthenticatedIBCompleteLeadsLazyRouteImport
      parentRoute: typeof AuthenticatedIBCompleteLazyRoute
    }
    '/_authenticated/_IBComplete/marketing': {
      id: '/_authenticated/_IBComplete/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof AuthenticatedIBCompleteMarketingLazyRouteImport
      parentRoute: typeof AuthenticatedIBCompleteLazyRoute
    }
    '/_authenticated/_IBComplete/performance': {
      id: '/_authenticated/_IBComplete/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AuthenticatedIBCompletePerformanceRouteImport
      parentRoute: typeof AuthenticatedIBCompleteLazyRoute
    }
    '/_authenticated/_IBOnboarding/kyc': {
      id: '/_authenticated/_IBOnboarding/kyc'
      path: '/kyc'
      fullPath: '/kyc'
      preLoaderRoute: typeof AuthenticatedIBOnboardingKycLazyRouteImport
      parentRoute: typeof AuthenticatedIBOnboardingLazyRoute
    }
    '/_authenticated/_IBOnboarding/questionnaire': {
      id: '/_authenticated/_IBOnboarding/questionnaire'
      path: '/questionnaire'
      fullPath: '/questionnaire'
      preLoaderRoute: typeof AuthenticatedIBOnboardingQuestionnaireLazyRouteImport
      parentRoute: typeof AuthenticatedIBOnboardingLazyRoute
    }
    '/_authenticated/triage/': {
      id: '/_authenticated/triage/'
      path: '/triage'
      fullPath: '/triage/'
      preLoaderRoute: typeof AuthenticatedTriageIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/triage/$triageID': {
      id: '/_authenticated/triage/$triageID'
      path: '/triage/$triageID'
      fullPath: '/triage/$triageID'
      preLoaderRoute: typeof AuthenticatedTriageTriageIDLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/triage/history': {
      id: '/_authenticated/triage/history'
      path: '/triage/history'
      fullPath: '/triage/history'
      preLoaderRoute: typeof AuthenticatedTriageHistoryLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_unauthenticated/logout/callback': {
      id: '/_unauthenticated/logout/callback'
      path: '/logout/callback'
      fullPath: '/logout/callback'
      preLoaderRoute: typeof UnauthenticatedLogoutCallbackRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/_IBComplete/ib-network/': {
      id: '/_authenticated/_IBComplete/ib-network/'
      path: '/ib-network'
      fullPath: '/ib-network/'
      preLoaderRoute: typeof AuthenticatedIBCompleteIbNetworkIndexLazyRouteImport
      parentRoute: typeof AuthenticatedIBCompleteLazyRoute
    }
    '/_authenticated/_IBComplete/ib-network/your-master-ib': {
      id: '/_authenticated/_IBComplete/ib-network/your-master-ib'
      path: '/ib-network/your-master-ib'
      fullPath: '/ib-network/your-master-ib'
      preLoaderRoute: typeof AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRouteImport
      parentRoute: typeof AuthenticatedIBCompleteLazyRoute
    }
    '/_authenticated/_IBComplete/ib-network/your-sub-ibs': {
      id: '/_authenticated/_IBComplete/ib-network/your-sub-ibs'
      path: '/ib-network/your-sub-ibs'
      fullPath: '/ib-network/your-sub-ibs'
      preLoaderRoute: typeof AuthenticatedIBCompleteIbNetworkYourSubIbsRouteImport
      parentRoute: typeof AuthenticatedIBCompleteLazyRoute
    }
    '/_authenticated/_IBComplete/marketing/': {
      id: '/_authenticated/_IBComplete/marketing/'
      path: '/'
      fullPath: '/marketing/'
      preLoaderRoute: typeof AuthenticatedIBCompleteMarketingIndexRouteImport
      parentRoute: typeof AuthenticatedIBCompleteMarketingLazyRoute
    }
    '/_authenticated/_IBComplete/marketing/banner-library': {
      id: '/_authenticated/_IBComplete/marketing/banner-library'
      path: '/banner-library'
      fullPath: '/marketing/banner-library'
      preLoaderRoute: typeof AuthenticatedIBCompleteMarketingBannerLibraryLazyRouteImport
      parentRoute: typeof AuthenticatedIBCompleteMarketingLazyRoute
    }
    '/_authenticated/triage/ib/': {
      id: '/_authenticated/triage/ib/'
      path: '/triage/ib'
      fullPath: '/triage/ib/'
      preLoaderRoute: typeof AuthenticatedTriageIbIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/triage/ib/$triageID': {
      id: '/_authenticated/triage/ib/$triageID'
      path: '/triage/ib/$triageID'
      fullPath: '/triage/ib/$triageID'
      preLoaderRoute: typeof AuthenticatedTriageIbTriageIDLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/triage/mam/': {
      id: '/_authenticated/triage/mam/'
      path: '/triage/mam'
      fullPath: '/triage/mam/'
      preLoaderRoute: typeof AuthenticatedTriageMamIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/triage/mam/$triageId': {
      id: '/_authenticated/triage/mam/$triageId'
      path: '/triage/mam/$triageId'
      fullPath: '/triage/mam/$triageId'
      preLoaderRoute: typeof AuthenticatedTriageMamTriageIdLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedIBCompleteMarketingLazyRouteChildren {
  AuthenticatedIBCompleteMarketingBannerLibraryLazyRoute: typeof AuthenticatedIBCompleteMarketingBannerLibraryLazyRoute
  AuthenticatedIBCompleteMarketingIndexRoute: typeof AuthenticatedIBCompleteMarketingIndexRoute
}

const AuthenticatedIBCompleteMarketingLazyRouteChildren: AuthenticatedIBCompleteMarketingLazyRouteChildren =
  {
    AuthenticatedIBCompleteMarketingBannerLibraryLazyRoute:
      AuthenticatedIBCompleteMarketingBannerLibraryLazyRoute,
    AuthenticatedIBCompleteMarketingIndexRoute:
      AuthenticatedIBCompleteMarketingIndexRoute,
  }

const AuthenticatedIBCompleteMarketingLazyRouteWithChildren =
  AuthenticatedIBCompleteMarketingLazyRoute._addFileChildren(
    AuthenticatedIBCompleteMarketingLazyRouteChildren,
  )

interface AuthenticatedIBCompleteLazyRouteChildren {
  AuthenticatedIBCompletePerformanceRoute: typeof AuthenticatedIBCompletePerformanceRoute
  AuthenticatedIBCompleteClientsLazyRoute: typeof AuthenticatedIBCompleteClientsLazyRoute
  AuthenticatedIBCompleteEarningsLazyRoute: typeof AuthenticatedIBCompleteEarningsLazyRoute
  AuthenticatedIBCompleteExportReportLazyRoute: typeof AuthenticatedIBCompleteExportReportLazyRoute
  AuthenticatedIBCompleteLeadsLazyRoute: typeof AuthenticatedIBCompleteLeadsLazyRoute
  AuthenticatedIBCompleteMarketingLazyRoute: typeof AuthenticatedIBCompleteMarketingLazyRouteWithChildren
  AuthenticatedIBCompleteIbNetworkYourSubIbsRoute: typeof AuthenticatedIBCompleteIbNetworkYourSubIbsRoute
  AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRoute: typeof AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRoute
  AuthenticatedIBCompleteIbNetworkIndexLazyRoute: typeof AuthenticatedIBCompleteIbNetworkIndexLazyRoute
}

const AuthenticatedIBCompleteLazyRouteChildren: AuthenticatedIBCompleteLazyRouteChildren =
  {
    AuthenticatedIBCompletePerformanceRoute:
      AuthenticatedIBCompletePerformanceRoute,
    AuthenticatedIBCompleteClientsLazyRoute:
      AuthenticatedIBCompleteClientsLazyRoute,
    AuthenticatedIBCompleteEarningsLazyRoute:
      AuthenticatedIBCompleteEarningsLazyRoute,
    AuthenticatedIBCompleteExportReportLazyRoute:
      AuthenticatedIBCompleteExportReportLazyRoute,
    AuthenticatedIBCompleteLeadsLazyRoute:
      AuthenticatedIBCompleteLeadsLazyRoute,
    AuthenticatedIBCompleteMarketingLazyRoute:
      AuthenticatedIBCompleteMarketingLazyRouteWithChildren,
    AuthenticatedIBCompleteIbNetworkYourSubIbsRoute:
      AuthenticatedIBCompleteIbNetworkYourSubIbsRoute,
    AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRoute:
      AuthenticatedIBCompleteIbNetworkYourMasterIbLazyRoute,
    AuthenticatedIBCompleteIbNetworkIndexLazyRoute:
      AuthenticatedIBCompleteIbNetworkIndexLazyRoute,
  }

const AuthenticatedIBCompleteLazyRouteWithChildren =
  AuthenticatedIBCompleteLazyRoute._addFileChildren(
    AuthenticatedIBCompleteLazyRouteChildren,
  )

interface AuthenticatedIBOnboardingLazyRouteChildren {
  AuthenticatedIBOnboardingKycLazyRoute: typeof AuthenticatedIBOnboardingKycLazyRoute
  AuthenticatedIBOnboardingQuestionnaireLazyRoute: typeof AuthenticatedIBOnboardingQuestionnaireLazyRoute
}

const AuthenticatedIBOnboardingLazyRouteChildren: AuthenticatedIBOnboardingLazyRouteChildren =
  {
    AuthenticatedIBOnboardingKycLazyRoute:
      AuthenticatedIBOnboardingKycLazyRoute,
    AuthenticatedIBOnboardingQuestionnaireLazyRoute:
      AuthenticatedIBOnboardingQuestionnaireLazyRoute,
  }

const AuthenticatedIBOnboardingLazyRouteWithChildren =
  AuthenticatedIBOnboardingLazyRoute._addFileChildren(
    AuthenticatedIBOnboardingLazyRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedIBCompleteLazyRoute: typeof AuthenticatedIBCompleteLazyRouteWithChildren
  AuthenticatedIBOnboardingLazyRoute: typeof AuthenticatedIBOnboardingLazyRouteWithChildren
  AuthenticatedIndexLazyRoute: typeof AuthenticatedIndexLazyRoute
  AuthenticatedTriageTriageIDLazyRoute: typeof AuthenticatedTriageTriageIDLazyRoute
  AuthenticatedTriageHistoryLazyRoute: typeof AuthenticatedTriageHistoryLazyRoute
  AuthenticatedTriageIndexLazyRoute: typeof AuthenticatedTriageIndexLazyRoute
  AuthenticatedTriageIbTriageIDLazyRoute: typeof AuthenticatedTriageIbTriageIDLazyRoute
  AuthenticatedTriageMamTriageIdLazyRoute: typeof AuthenticatedTriageMamTriageIdLazyRoute
  AuthenticatedTriageIbIndexLazyRoute: typeof AuthenticatedTriageIbIndexLazyRoute
  AuthenticatedTriageMamIndexLazyRoute: typeof AuthenticatedTriageMamIndexLazyRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIBCompleteLazyRoute:
    AuthenticatedIBCompleteLazyRouteWithChildren,
  AuthenticatedIBOnboardingLazyRoute:
    AuthenticatedIBOnboardingLazyRouteWithChildren,
  AuthenticatedIndexLazyRoute: AuthenticatedIndexLazyRoute,
  AuthenticatedTriageTriageIDLazyRoute: AuthenticatedTriageTriageIDLazyRoute,
  AuthenticatedTriageHistoryLazyRoute: AuthenticatedTriageHistoryLazyRoute,
  AuthenticatedTriageIndexLazyRoute: AuthenticatedTriageIndexLazyRoute,
  AuthenticatedTriageIbTriageIDLazyRoute:
    AuthenticatedTriageIbTriageIDLazyRoute,
  AuthenticatedTriageMamTriageIdLazyRoute:
    AuthenticatedTriageMamTriageIdLazyRoute,
  AuthenticatedTriageIbIndexLazyRoute: AuthenticatedTriageIbIndexLazyRoute,
  AuthenticatedTriageMamIndexLazyRoute: AuthenticatedTriageMamIndexLazyRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedInactivityLogoutLazyRoute: typeof UnauthenticatedInactivityLogoutLazyRoute
  UnauthenticatedProgramSelectionLazyRoute: typeof UnauthenticatedProgramSelectionLazyRoute
  UnauthenticatedLogoutCallbackRoute: typeof UnauthenticatedLogoutCallbackRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedInactivityLogoutLazyRoute:
    UnauthenticatedInactivityLogoutLazyRoute,
  UnauthenticatedProgramSelectionLazyRoute:
    UnauthenticatedProgramSelectionLazyRoute,
  UnauthenticatedLogoutCallbackRoute: UnauthenticatedLogoutCallbackRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
